import React from 'react'
import Card from '../../components/card/Card'

const ReportBug = () => {
  return (
    <div className='--mt'>
        <Card>
            <h3>Report Bug at surajbintw@gmail.com</h3>
        </Card>
    </div>
  )
}

export default ReportBug